import {Component} from '@angular/core';

import {AbstractProposalPropertyEdit} from '../../abstract-proposal-property-edit';

@Component({
  selector: 'ax-custom-rich-text-edit',
  templateUrl: './custom-rich-text-edit.component.html',
})
export class CustomRichTextEditComponent extends AbstractProposalPropertyEdit {}
